// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ju5d","rootNoMargin":"styles_rootNoMargin__3XzKd"};